// extracted by mini-css-extract-plugin
module.exports = {"social-menu":"Socials_social-menu__ock8r","social-icon":"Socials_social-icon__xU_7y","social-link":"Socials_social-link__HdXvx"};